import { MyLiNKQueryKeys } from "constants/my-link-query-keys";
import UserBookmarkSortOption from "models/enumerations/sorting/user-bookmarks/user-bookmark-sort-option";
import UserBookmarkRecord from "models/view-models/user-bookmark-record";
import { useQuery } from "react-query";
import { t } from "utilities/localization-utils";
import UserBookmarkService, {
    ListBookmarksQueryParams,
} from "utilities/services/user-bookmarks/user-bookmark-service";
import { ToastManager } from "utilities/toast/toast-manager";
export interface BookmarkQueryResponse {
    bookmarks: UserBookmarkRecord[];
    bookmarksLength: number;
}
export interface UseAllBookmarkQueryOptions extends ListBookmarksQueryParams {
    onSuccess?: (newVal: BookmarkQueryResponse) => void;
    sortBy?: UserBookmarkSortOption;
}

export default function useAllBookmarksQuery(
    options?: UseAllBookmarkQueryOptions
) {
    const {
        data: bookmarks,
        isLoading,
        refetch: refetchAllBookmarks,
    } = useQuery({
        queryKey: [
            MyLiNKQueryKeys.Bookmarks,
            options?.currentUserOnly,
            options?.skip,
            options?.take,
            options?.sortBy,
            options?.searchText,
        ],
        queryFn: async () => await fetchBookmarks(options),
        onSuccess: options?.onSuccess,
        keepPreviousData: true,
    });

    return { bookmarks, isLoading, refetchAllBookmarks };
}

const fetchBookmarks = async (options?: UseAllBookmarkQueryOptions) => {
    try {
        const result = await UserBookmarkService.list({
            skip: options?.skip,
            take: options?.take,
            currentUserOnly: options?.currentUserOnly,
            sortBy: options?.sortBy,
            searchText: options?.searchText,
        });

        if (result.result?.hasErrors()) {
            throw new Error();
        }
        return {
            bookmarks: result.resultObjects,
            bookmarksLength: result.rowCount,
        };
    } catch (err) {
        ToastManager.error(
            t("errors-actionResource", {
                action: t("loading"),
                resource: t("bookmark"),
            })
        );
    }
};
